/**
 * Check if an error is a network/offline error
 * @param {Error} error - The error to check
 * @returns {boolean} Whether the error indicates a network issue
 */
export const isNetworkError = (error) => {
  if (!error) return false;

  // Firebase errors have a code property like "auth/network-request-failed"
  if (error.code === "auth/network-request-failed") {
    return true;
  }

  // Webpack chunk loading errors (dynamic imports fail when offline)
  if (
    error.name === "ChunkLoadError" ||
    error.message?.includes("Loading chunk")
  ) {
    return true;
  }

  const errorString =
    `${error.message || ""} ${error.name || ""} ${error.code || ""}`.toLowerCase();

  const networkPatterns = [
    "failed to fetch",
    "network request failed",
    "networkerror",
    "network error",
    "err_network",
    "err_internet_disconnected",
    "the internet connection appears to be offline",
    "a server with the specified hostname could not be found",
    "net::err_",
    "enotfound",
    "econnrefused",
    "etimedout",
    "enetunreach",
    // Firebase-specific errors when offline
    "auth/network-request-failed",
    "network-request-failed",
    "a network error",
    "offline",
    // Webpack chunk loading errors
    "chunkloaderror",
    "loading chunk",
  ];

  return networkPatterns.some((pattern) => errorString.includes(pattern));
};

export default isNetworkError;
